import React, { useState, useEffect } from "react";
import { Plus, Eye, Trash2, Edit } from "lucide-react";
import { PostScheduleDashboard } from "../components/PostScheduleDashboard";
import { PostCalendar } from "../components/PostCalendar";
import { AIScheduleGenerator } from "../components/AIScheduleGenerator";
import { useAppContext } from "../context/AppContext";
import { FeatureRestriction } from "../components/FeatureRestriction";
import { usePlanFeatures } from "../hooks/usePlanFeatures";
import { useLoading } from "@/context/LoadingContext";
import { useTranslation } from "react-i18next";
import { notify } from "@/utils/toast";

interface ScheduledPost {
  id: string;
  content: string;
  platforms: string[];
  scheduledDate: Date;
  status: "scheduled" | "published" | "failed";
  imageUrl?: string;
}

export const SchedulePage: React.FC = () => {
  const { state } = useAppContext();
  const { canUseFeature } = usePlanFeatures();

  const canSchedulePosts = canUseFeature("ipro");

  if (!canSchedulePosts) {
    return (
      <FeatureRestriction feature="Schedule Posts" requiredPlan="ipro">
        <div className="p-8 text-center">
          <p className="theme-text-secondary">
            Schedule your content across multiple platforms with AI-powered
            optimal timing
          </p>
        </div>
      </FeatureRestriction>
    );
  }

  return (
    <div className="theme-card-bg p-4">
      <div className="space-y-6">
        <PostScheduleDashboard campaignId={state.selectedProfile?.id || ""} />
      </div>
    </div>
  );
};
